import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiConfig } from "../config/api.config";

function formatCOP(value) {
  if (value === null || value === undefined || isNaN(value)) return "$ 0";
  return new Intl.NumberFormat("es-CO", {
    style: "currency", currency: "COP",
    minimumFractionDigits: 0, maximumFractionDigits: 0,
  }).format(value);
}

function formatPeriodo(p) {
  if (!p) return "";
  const [y, m] = p.split("-");
  const meses = ["","Enero","Febrero","Marzo","Abril","Mayo","Junio",
    "Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];
  return `${meses[parseInt(m)]} ${y}`;
}

export default function IndicadorLey9993() {
  const navigate = useNavigate();
  const [datos, setDatos]           = useState(null);
  const [loading, setLoading]       = useState(true);
  const [error, setError]           = useState(null);
  const [expandido, setExpandido]   = useState(false);

  useEffect(() => {
    fetch(apiConfig.getUrl("/api/hacienda/ley-99-93/"), { credentials: "include" })
      .then(r => r.json())
      .then(data => {
        if (data.error) throw new Error(data.error);
        setDatos(data);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  const card = {
    background: "#fff", borderRadius: "16px",
    border: "1px solid #e5e7eb",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    padding: "1.5rem", marginBottom: "1.5rem",
  };

  if (loading) return <div style={{ padding: "3rem", textAlign: "center", color: "#6b7280" }}>Cargando...</div>;

  return (
    <div style={{ minHeight: "100vh", background: "#f3f4f6", padding: "2rem 1.5rem" }}>
      <div style={{ maxWidth: "860px", margin: "0 auto" }}>

        <button type="button" onClick={() => navigate("/hacienda-presupuesto")}
          style={{ background: "#e5e7eb", color: "#111827", border: "none",
            borderRadius: "10px", padding: "0.7rem 1rem",
            cursor: "pointer", fontWeight: 600, marginBottom: "1.5rem" }}>
          ← Volver a Hacienda
        </button>

        <div style={{ marginBottom: "1.5rem" }}>
          <h1 style={{ margin: 0, color: "#163b8c", fontSize: "2rem", fontWeight: 800 }}>
            Indicador Ley 99/93
          </h1>
          <p style={{ marginTop: "0.5rem", color: "#6b7280" }}>
            Tasa ambiental — 1% de los ingresos corrientes de libre destinación
          </p>
        </div>

        {error && (
          <div style={{ background: "#fef2f2", border: "1px solid #fca5a5",
            borderRadius: "12px", padding: "1rem", color: "#991b1b", marginBottom: "1rem" }}>
            ⚠️ {error}
          </div>
        )}

        {!datos && !error && !loading && (
          <div style={card}>
            <p style={{ color: "#6b7280", margin: 0 }}>
              No hay cargues disponibles. Primero debes subir los archivos en el{" "}
              <span style={{ color: "#1d4ed8", cursor: "pointer", fontWeight: 600 }}
                onClick={() => navigate("/hacienda-presupuesto/transformador")}>
                Transformador Presupuestal
              </span>.
            </p>
          </div>
        )}

        {datos && (
          <>
            {/* ── Bloque 1: 1% ICLD total ── */}
            <div style={card}>
              <div style={{ marginBottom: "1rem", fontSize: "0.85rem", color: "#6b7280" }}>
                Periodo de referencia: <strong>{formatPeriodo(datos.periodo)}</strong>
              </div>
              <h2 style={{ margin: "0 0 1rem", color: "#163b8c", fontSize: "1.1rem" }}>
                1% sobre Ingresos Corrientes de Libre Destinación (fuente 11001)
              </h2>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.95rem" }}>
                <tbody>
                  <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
                    <td style={{ padding: "0.85rem 0.5rem", color: "#6b7280" }}>
                      Recaudo total fuente 11001
                      <div style={{ fontSize: "0.8rem", color: "#9ca3af" }}>
                        Ingresos corrientes de libre destinación
                      </div>
                    </td>
                    <td style={{ padding: "0.85rem 0.5rem", textAlign: "right", fontWeight: 600 }}>
                      {formatCOP(datos.icld_recaudo)}
                    </td>
                  </tr>
                  <tr style={{ background: "#f0f9ff" }}>
                    <td style={{ padding: "0.85rem 0.5rem", fontWeight: 700, color: "#163b8c" }}>
                      1% — Tasa ambiental Ley 99/93
                    </td>
                    <td style={{ padding: "0.85rem 0.5rem", textAlign: "right",
                      fontWeight: 800, fontSize: "1.3rem", color: "#163b8c" }}>
                      {formatCOP(datos.indicador_1pct_icld)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* ── Bloque 2: 1% sobre CCPET específicos ── */}
            <div style={{ ...card, padding: 0, overflow: "hidden" }}>
              {/* Encabezado clickeable */}
              <div
                onClick={() => setExpandido(!expandido)}
                style={{ padding: "1.25rem 1.5rem", cursor: "pointer",
                  display: "flex", justifyContent: "space-between", alignItems: "center",
                  background: expandido ? "#eff6ff" : "#fff",
                  borderBottom: expandido ? "1px solid #dbeafe" : "none" }}>
                <div>
                  <h2 style={{ margin: 0, color: "#163b8c", fontSize: "1.1rem" }}>
                    1% sobre CCPET específicos (Ley 99/93)
                  </h2>
                  <p style={{ margin: "0.25rem 0 0", fontSize: "0.85rem", color: "#6b7280" }}>
                    {datos.detalle?.length} conceptos — Total recaudo:{" "}
                    <strong>{formatCOP(datos.total_recaudo_ccpets)}</strong>
                  </p>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontWeight: 800, fontSize: "1.2rem", color: "#163b8c" }}>
                    {formatCOP(datos.indicador_1pct_ccpets)}
                  </div>
                  <div style={{ fontSize: "0.8rem", color: "#6b7280", marginTop: "0.2rem" }}>
                    {expandido ? "▲ Ocultar detalle" : "▼ Ver detalle"}
                  </div>
                </div>
              </div>

              {/* Resumen siempre visible */}
              <div style={{ padding: "0.85rem 1.5rem", background: "#f0f9ff",
                display: "flex", justifyContent: "space-between", alignItems: "center",
                borderBottom: "1px solid #dbeafe" }}>
                <span style={{ fontWeight: 700, color: "#163b8c" }}>
                  1% sobre recaudo de conceptos específicos
                </span>
                <span style={{ fontWeight: 800, fontSize: "1.2rem", color: "#163b8c" }}>
                  {formatCOP(datos.indicador_1pct_ccpets)}
                </span>
              </div>

              {/* Tabla desplegable */}
              {expandido && (
                <div>
                  {/* Header tabla */}
                  <div style={{ display: "grid", gridTemplateColumns: "1.5fr 2fr 1fr",
                    padding: "0.6rem 1.5rem", background: "#dbeafe",
                    fontWeight: 700, fontSize: "0.82rem", color: "#1e40af" }}>
                    <span>CCPET</span>
                    <span>NOMBRE</span>
                    <span style={{ textAlign: "right" }}>1% RECAUDO</span>
                  </div>

                  {datos.detalle?.map((item, idx) => (
                    <div key={item.ccpet + item.nombre} style={{
                      display: "grid", gridTemplateColumns: "1.5fr 2fr 1fr",
                      padding: "0.6rem 1.5rem",
                      background: idx % 2 === 0 ? "#fff" : "#f0f6ff",
                      borderBottom: "1px solid #e0eaff",
                      fontSize: "0.85rem",
                    }}>
                      <span style={{ fontFamily: "monospace", color: "#374151", fontSize: "0.8rem" }}>
                        {item.ccpet}
                      </span>
                      <span style={{ color: "#4b5563", paddingRight: "0.5rem" }}>
                        {item.nombre}
                      </span>
                      <span style={{ textAlign: "right", fontWeight: 500, color: "#163b8c" }}>
                        {formatCOP(parseFloat(item.total_recaudo) * 0.01)}
                      </span>
                    </div>
                  ))}

                  {/* Total */}
                  <div style={{ display: "grid", gridTemplateColumns: "1.5fr 2fr 1fr",
                    padding: "0.75rem 1.5rem", background: "#dbeafe",
                    fontWeight: 700, fontSize: "0.9rem" }}>
                    <span style={{ gridColumn: "1/3", color: "#1e40af" }}>Total 1%</span>
                    <span style={{ textAlign: "right", color: "#1e40af" }}>
                      {formatCOP(datos.indicador_1pct_ccpets)}
                    </span>
                  </div>

                  {/* 1% del total */}
                  <div style={{ padding: "0.85rem 1.5rem", background: "#eff6ff",
                    display: "flex", justifyContent: "space-between",
                    fontWeight: 700, fontSize: "0.95rem", color: "#163b8c" }}>
                    <span>1% sobre total conceptos específicos</span>
                    <span style={{ fontSize: "1.1rem" }}>
                      {formatCOP(datos.indicador_1pct_ccpets)}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}